import { FieldIndex, FieldKey } from '../index';

export const fieldIndices = (key: FieldKey | null): FieldIndex[] => {
  return key ? key.fieldIndices : [];
};
